import { IDadataAddressResponse } from '../dadata/dadata-address.model';
import { CuttingEngine } from '../user/cutting-settings.model';
import { CuttingOrderActiveControlProgram } from './cutting-order-active-control-program.model';
import { CuttingOrderStatus } from './cutting-order-status.model';
import { CuttingPointOfIssue } from './cutting-point-of-issue.model';
import { MatBaseGroupDiscount } from './mat-base-group-discount.model';

export class CuttingOrderDiscount {
  promoActive: boolean;
  discount: number;
  materialDiscount: MatBaseGroupDiscount[];
  operationDiscount: MatBaseGroupDiscount[];
}

export class CuttingOrderDetail {
  id: number;
  name: string;
  dateCreate: Date;
  dateEdit: Date;
  dateOrdering?: Date;
  dateConfirm?: Date;
  datePayming?: Date;
  dateOfIssue?: Date;
  plannedDateOfIssue?: Date;
  amount: number;
  amountWithoutVAT: number;
  amountWithoutDiscount: number;
  amountTempEstimate: number;
  amountTempEstimateWithoutDiscount: number;
  amountTempEstimateWithoutVAT: number;
  amountVAT: number;
  amountTempVAT: number;
  sumPayments: number;
  note: string;
  managerNote: string;
  clientNote: string;
  status: CuttingOrderStatus;
  clientName: string;
  clientPhone: string;
  clientCompany: string;
  clientEmail: string;
  clientId: number;
  cuttingProccess: boolean;
  factoryOrderId: string;
  invoiceNumber: string;
  managerId: number;
  managerName: string;
  managerPhone: string;
  factoryId?: number;
  archived: boolean;
  uid1C: string;
  discount: CuttingOrderDiscount;
  questionId: number;
  deliveryType: DeliveryTypeEnum;
  pointOfIssue: CuttingPointOfIssue;
  hasNoteInPanels: boolean;
  weight: number;
  cuttingEngine: CuttingEngine = CuttingEngine.OldEngine;
  usedDiskSpace: number;
  deliveryAddress: IDadataAddressResponse;
  activeControlProgram?: CuttingOrderActiveControlProgram;
  productionFileName?: string;
  drawingsLibraryFileName?: string;
  whoCreateOrder: string;
  hasUnpaidUnlicensedModels: boolean;
  vatIncludeInPrice: boolean;
  vatPercent: number;

  constructor(order?: CuttingOrderDetail | any) {
    order = order || {};
    this.id = order.id || 0;
    this.name = order.name || '';
    this.dateCreate = order.dateCreate || undefined;
    this.dateEdit = order.dateEdit || undefined;
    this.amount = order.amount || 0;
    this.amountWithoutVAT = order.amountWithoutVAT || 0;
    this.amountTempEstimateWithoutVAT = order.amountTempEstimateWithoutVAT || 0;
    this.amountVAT = order.amountVAT || 0;
    this.amountTempVAT = order.amountTempVAT || 0;
    this.clientName = order.clientName || '';
    this.clientEmail = order.clientEmail || '';
    this.clientPhone = order.clientPhone || '';
    this.clientCompany = order.clientCompany || '';
    this.clientId = order.clientId || 0;
    this.note = order.note || '';
    this.managerNote = order.managerNote || '';
    this.clientNote = order.clientNote || '';
    this.invoiceNumber = order.invoiceNumber || '';
    this.status = order.status || undefined;
    this.dateOrdering = order.dateOrdering || undefined;
    this.dateConfirm = order.dateConfirm || undefined;
    this.dateOfIssue = order.dateOfIssue || undefined;
    this.plannedDateOfIssue = order.plannedDateOfIssue || undefined;
    this.factoryOrderId = order.factoryOrderId || '';
    this.managerId = order.managerId || undefined;
    this.cuttingProccess = order.cuttingProccess || false;
    this.managerName = order.managerName || '';
    this.amountTempEstimateWithoutDiscount = order.amountTempEstimateWithoutDiscount || 0;
    this.factoryId = order.factoryId || undefined;
    this.sumPayments = order.sumPayments || 0;
    this.datePayming = order.datePayming || undefined;
    this.archived = order.archived || false;
    this.uid1C = order.uid1C || '';
    this.discount = order.discount || new CuttingOrderDiscount();
    this.amountWithoutDiscount = order.amountWithoutDiscount || 0;
    this.questionId = order.questionId || null;
    this.deliveryType = order.deliveryType || 0;
    this.deliveryAddress = order.deliveryAddress || undefined;
    this.weight = order.weight || 0;
    this.pointOfIssue = order.pointOfIssue || undefined;
    this.hasNoteInPanels = order.hasNoteInPanels || undefined;
    this.cuttingEngine = order.cuttingEngine || undefined;
    this.usedDiskSpace = order.usedDiskSpace || 0;
    this.activeControlProgram = order.activeControlProgram || undefined;
    this.productionFileName = order.productionFileName || undefined;
    this.drawingsLibraryFileName = order.drawingsLibraryFileName || undefined;
    this.whoCreateOrder = order.whoCreateOrder || '';
    this.hasUnpaidUnlicensedModels = order.hasUnpaidUnlicensedModels || false;
    this.managerPhone = order.managerPhone || '';
    this.vatIncludeInPrice = order.vatIncludeInPrice || false;
    this.vatPercent = order.vatPercent || null;
  }
}

export enum DeliveryTypeEnum {
  None,
  Pickup,
  Courier,
}
